import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import { toggleErrorConsole } from '../../store/errorSlice';
import { selectUserPreferences } from '../../store/preferencesSlice';
import { FiAlertTriangle } from 'react-icons/fi';

const ErrorIndicator: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const unreadCount = useSelector((state: RootState) => state.error.unreadCount);
  const totalErrors = useSelector((state: RootState) => state.error.errors.length);
  const preferences = useSelector(selectUserPreferences);

  // Don't render if user has disabled error console in preferences
  if (!preferences.showErrorConsole) {
    return null;
  }

  return (
    <button
      onClick={() => dispatch(toggleErrorConsole())}
      className={`relative p-2 rounded-lg transition-colors ${
        unreadCount > 0
          ? 'text-red-500 hover:bg-red-50'
          : totalErrors > 0
            ? 'text-gray-400 hover:bg-gray-50 hover:text-gray-600'
            : 'text-gray-300 hover:bg-gray-50 hover:text-gray-400'
      }`}
      title={
        unreadCount > 0
          ? `${unreadCount} unread error${unreadCount > 1 ? 's' : ''}`
          : totalErrors > 0
            ? 'View error history'
            : 'No errors'
      }
    >
      <FiAlertTriangle size={20} />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ErrorIndicator;
